<template>
  <div>
    <div ref="trigger">
      <slot name="trigger">
        <Button class="hidden md:block"> <PlusIcon class="h-3" /> New </Button>
      </slot>
    </div>
    <div
      ref="dropdownMenu"
      class="z-20 hidden bg-white rounded-lg shadow-sm w-52 dark:bg-gray-700"
    >
      <div class="flex *:cursor-pointer">
        <div
          class="w-6/12 justify-center flex-shrink-0 text-xs items-center flex flex-col gap-2 p-4 border-r-0 hover:bg-blue-50 hover:border-blue-200 hover:text-primary-700 border border-transparent rounded-s-lg"
          @click="toggleEventModal"
        >
          <CalendarCheck class="h-5" />
          <div>Event</div>
        </div>
        <div
          class="w-6/12 justify-center flex-grow-0 text-xs items-center flex flex-col gap-2 p-4 hover:bg-blue-50 hover:border-blue-200 hover:text-primary-700 border border-transparent rounded-e-lg"
          @click="toggleAppointmentModal"
        >
          <DeliveryTruckIcon class="h-5" />
          <div>Appointment</div>
        </div>
      </div>
    </div>
    <CalendarEventModal
      v-if="eventModal"
      auto-open
      @hide-modal="toggleEventModal"
      @created="refreshTimelineEvents"
    />
    <AppointmentCreateModal
      v-if="appointmentModal"
      @hide-modal="toggleAppointmentModal"
      @created="refreshTimelineEvents"
    />
  </div>
</template>

<script setup lang="ts">
import type { DropdownInterface, DropdownOptions } from "flowbite";
import { Dropdown } from "flowbite";
import { onMounted, ref } from "vue";

import Button from "@/components/Seranova/Buttons/Button.vue";
import AppointmentCreateModal from "@/AppointmentCreateModal/AppointmentCreateModal.vue";
import CalendarCheck from "@/images/CalendarCheck.svg?component";
import DeliveryTruckIcon from "@/images/delivery_truck.svg?component";
import PlusIcon from "@/images/plus-outline.svg?component";
import CalendarEventModal from "@/Scheduler/CalendarEventModal.vue";
import { useEventCalendar } from "@/SchedulerV2/useEventCalendar";

const dropdownMenu = ref<HTMLElement | null>(null);
const trigger = ref<HTMLElement | null>(null);
const dropdown = ref<DropdownInterface | null>(null);
const eventModal = ref(false);
const appointmentModal = ref(false);
const { refreshTimeline } = useEventCalendar();

onMounted(() => {
  // options with default values
  const options: DropdownOptions = {
    placement: "bottom-end",
    triggerType: "click",
    offsetSkidding: 0,
    offsetDistance: 10,
    delay: 300
  };
  dropdown.value = new Dropdown(dropdownMenu.value, trigger.value, options);
});

const toggleEventModal = () => {
  eventModal.value = !eventModal.value;
};

const toggleAppointmentModal = () => {
  appointmentModal.value = !appointmentModal.value;
};

const refreshTimelineEvents = () => {
  refreshTimeline();
};
</script>

<style scoped></style>
